/**
 * User-facing copy for the Premiere Pro panel download page.
 *
 * Kept in a constants file per the repo convention (no hardcoded UI strings in components).
 * Every claim is grounded in what the panel actually does — see premiere-panel/
 * SEND-TO-FRIENDS.md and signing/README.md. Do not add features the panel doesn't have.
 */

export const PLUGIN_EYEBROW = "Premiere Pro panel · Mac and Windows";

export const PLUGIN_DOWNLOAD_TITLE = "Cut Premiere from a spreadsheet.";

export const PLUGIN_DOWNLOAD_SUBTITLE =
  "Transcribe a clip without leaving Premiere, then tick the lines you want. Each one lands on your open sequence, cut from your own local file.";

export const PLUGIN_DOWNLOAD_CTA = "Download the panel";

export const PLUGIN_DOWNLOAD_FINE =
  "Free to download · about 75 KB · Premiere Pro 2022 or newer, on Mac or Windows. What you transcribe in it counts toward your plan's hours.";

// Free to download on every plan (2026-10-25), so a signed-out visitor only needs to sign in:
// the email is how we know who runs the panel. Their plan's hours cap what it transcribes.
export const PLUGIN_SIGN_IN_CTA = "Sign in to download";

export const PLUGIN_SIGN_IN_SECONDARY = "See plans";

export const PLUGIN_SIGN_IN_FINE =
  "Free to download, on Mac or Windows with Premiere Pro 2022 or newer. Your first hour of transcription is free.";

export const PLUGIN_SETUP_EYEBROW = "Setup";

export const PLUGIN_SETUP_HEADING = "Three steps, about two minutes.";

export const PLUGIN_SETUP_STEPS = [
  {
    title: "Get the installer",
    body: "Premiere can't open a .zxp on its own, so grab a free installer first. You only ever do this once.",
  },
  {
    title: "Install the panel",
    body: "Drag CherryClipz.zxp onto the installer window. Then fully quit Premiere (⌘Q on a Mac, Ctrl+Q on Windows) and open it again — closing the window isn't enough.",
  },
  {
    title: "Open it and sign in",
    body: "Window ▸ Extensions ▸ CherryClipz. Enter your email and we'll send you a 6-digit code.",
  },
];

export const PLUGIN_INSTALLER_PRIMARY = {
  name: "Get ZXPInstaller",
  url: "https://zxpinstaller.com",
};

export const PLUGIN_INSTALLER_ALT_PREFIX = "or use";

export const PLUGIN_INSTALLER_ALT = {
  name: "Anastasiy's Extension Manager",
  url: "https://install.anastasiy.com",
};

export const PLUGIN_USE_EYEBROW = "Then what";

export const PLUGIN_USE_HEADING = "Your first cut.";

export const PLUGIN_USE_STEPS = [
  "Select a clip in Premiere's Project panel and hit Transcribe — only the audio uploads, so it's quick.",
  "Open the sequence you want the cut to land on. An empty one is fine.",
  "Tick a line in the spreadsheet and it drops onto your timeline. Untick to pull it back out.",
];

export const PLUGIN_UNVERIFIED_NOTE =
  'The installer may call CherryClipz an "unverified publisher". That\'s expected for a panel distributed directly rather than through Adobe\'s store — click through and it installs normally.';

/** Windows builds shipped 2026-10-19 (v0.4) and have had little real use yet: say so, kindly. */
export const PLUGIN_WINDOWS_NOTE = "Windows support is new. If anything doesn't work on your PC, email us and we'll fix it:";

export const PLUGIN_HELP_PREFIX = "Stuck? Send us a screenshot:";

export const PLUGIN_GENERIC_ERROR =
  "Couldn't start the download. Try again, or email us and we'll send it over directly.";
